import { Timeline } from './../../../auth/_models/timeline';
import { BlockUi } from './../../../auth/_helpers/block-ui';
import { StorageService } from './../../../auth/_services/storage.service';
import { ActivatedRoute } from '@angular/router';
import { Pet } from './../../../auth/_models/pet';
import { PetsService } from 'src/app/auth/_services/pets.service';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';

declare let CustomScript: any;
declare let $: any;

@Component({
  selector: 'app-my-pet-add-photo',
  templateUrl: './my-pet-add-photo.component.html',
  styleUrls: ['./my-pet-add-photo.component.css']
})
export class MyPetAddPhotoComponent implements OnInit, AfterViewInit {

  public photo = null;
  profilePhoto: boolean;
  public editor = ClassicEditor;
  public model = {
    editorData: ''
  };
  pet: Pet;

  constructor(
    private _storageService: StorageService,
    private _route: ActivatedRoute,
    private _petsService: PetsService,
    private _blockui: BlockUi,
  ) { }

  ngOnInit() {

    this._route.parent.params.subscribe(params => {
      const uuid = params['id'];
      this.pet = new Pet({ uuid: uuid });
    });

  }

  ngAfterViewInit(): void {
    CustomScript.initSwitchery();
  }

  isProfilePhoto(event) {
    this.profilePhoto = event.target.checked;
  }

  chooseFile(event) {
    const that = this;

    this.photo = event.target.files[0];

    if (this.photo) {
      console.log('Arquivo selecionado: ', this.photo);
      const reader = new FileReader();

      reader.onload = function (e) {
        $('.new-photo').attr('src', e.target['result']);
      };

      reader.readAsDataURL(this.photo);
    }
  }

  clickInputFile() {
    $('.input-new-foto').click();
  }

  confirmPhoto() {

    if (this.photo) {

      // const photoUuid = `photo-${this.pet.uuid}${this.getHashDate()}.png`;
      //      const path = `pets/${this.pet.uuid}/photos/` + photoUuid;

      /** Trava a interface */
      this._blockui.block();

      const photoUuid = this.profilePhoto ? `photo-${this.pet.uuid}.png` : `photo-${this.pet.uuid}${this.getHashDate()}.png`;
      const path = this.profilePhoto ? `pets/${this.pet.uuid}/photos/profile/` + photoUuid : `pets/${this.pet.uuid}/photos/` + photoUuid;

      this._storageService
        .uploadPhoto(path, this.photo)
        .on('state_changed',
          (snapshot: firebase.storage.UploadTaskSnapshot) => {

            console.log('Progress: ' + Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100) + '%');

          },
          (error) => {

            console.error('Falha ao realizar upload do arquivo: ' + error);
            this._blockui.unblock();

          },
          () => {
            console.log('Upload finalizado!');

            this._storageService
              .getPhotoUrl(path)
              .then(url => {

                if (this.profilePhoto) {
                  this._petsService.insertProfilePhoto(this.pet, url);
                } else {
                  this.insertTimelinePhoto(photoUuid, url);
                }

              })
              .catch(err => {
              });

            this._blockui.unblock();

          });

      this.photo = null;
    }
  }

  insertTimelinePhoto(
    photoName: string,
    photoUrl: string
  ) {

    /*
    description: string;            // Descrição
    type: string;
    photo: string;
    */

    const timeline: Timeline = new Timeline({
      description: this.model.editorData,
      type: 'photo',
      photo: photoName,
      photoUrl: photoUrl,
    });

    this._petsService
      .insertTimeline(this.pet, timeline)
      .then((data) => {
        console.log('Inserido');

        // todo redirecionar
      })
      .catch((err) => {
        console.error('não atualizou');
      });

  }

  getHashDate() {

    const date = new Date(),
      day = date.getDate().toString(),
      dayF = (day.length === 1) ? '0' + day : day,
      mou = (date.getMonth() + 1).toString(),
      mouF = (mou.length === 1) ? '0' + mou : mou,
      year = date.getFullYear().toString(),
      hour = date.getHours().toString(),
      hourF = (hour.length === 1) ? '0' + hour : hour,
      min = date.getMinutes().toString(),
      minF = (min.length === 1) ? '0' + min : min,
      sec = date.getSeconds().toString(),
      secF = (sec.length === 1) ? '0' + sec : sec;

    return year + mouF + dayF + hourF + minF + secF;

  }
}
